<ng-container *ngIf="spPlayerLazy && (isActivated$ | async) === false && sourceProvider !== 'html5'">
    <div class="sp-player-preview" (click)="activatePlayer()">
        <img
            *ngIf="getThumbnailUrl()"
            class="sp-player-preview__thumbnail"
            [src]="getThumbnailUrl()"
            [alt]="playerTitle || 'Video thumbnail'"
            loading="lazy"
        />
        <button type="button" class="sp-player-preview__play-btn" aria-label="Play video">
            <svg viewBox="0 0 18 18">
                <path
                    d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"
                />
            </svg>
        </button>
    </div>
</ng-container>
